import { formatDate } from '../../../../utils/dateHelper';
import { Button } from 'primereact/button';
import styles from "../../cards.module.scss"

function DocumentItem({ document, onUpdate, onDelete }) {
  const handleDelete = (e) => {
    console.log(e);
    e.stopPropagation();
    onDelete();
  };

  return (
    <div
      className={`${styles.projectCardGrid} ${styles.projectCard} `}
      onClick={onUpdate}>
      <i className={`${styles.cardIcon} pi pi-file-pdf`} />

      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>
            {document.label}</p>
          <span className={styles.subtitle}>{formatDate(document.last_update)}</span>
        </div>
      </div>

      <Button
        rounded
        icon="pi pi-trash"
        severity="danger"
        onClick={handleDelete}
        outlined
        size="small"
        className={styles.button}
      />
    </div>
  );
}

export default DocumentItem;
